export const mapReverseGeocodePrecisionMeters = 10;

const roundCoordinateToMeters = (value, meters, latitudeForLongitude) => {
  const metersPerDegree =
    typeof latitudeForLongitude === "number"
      ? 111320 * Math.cos((latitudeForLongitude * Math.PI) / 180)
      : 111320;
  const decimalPlaces = Math.max(
    0,
    Math.ceil(Math.log10(metersPerDegree / meters)),
  );

  return Number(value.toFixed(decimalPlaces));
};

export const getRoundedReverseGeocodeCoordinates = (item) => {
  const lat = Number(item?.lat);
  const lng = Number(item?.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return {
    lat: roundCoordinateToMeters(lat, mapReverseGeocodePrecisionMeters),
    lng: roundCoordinateToMeters(
      lng,
      mapReverseGeocodePrecisionMeters,
      lat,
    ),
  };
};

export const getUsefulReverseGeocodeName = (result) => {
  const name = typeof result?.name === "string" ? result.name.trim() : "";

  if (!name || /^Dropped pin\b/i.test(name)) {
    return null;
  }

  return name;
};
